// @flow
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Input, Loader, Grid } from 'semantic-ui-react';
import { assign } from 'lodash';
import { parse } from 'query-string';
import { deleteFilter, getGridData } from '../../modules/client';
import Poseidon from '../../containers/PoseidonContainer';
import FloatingActionsHover from '../molecules/FloatingActionsHover';
import NewFilterModal from '../molecules/NewFilterModal';
import ShareModal from '../molecules/ShareModal';
import DeleteModal from '../molecules/DeleteModal';
import CreateGridModal from '../molecules/CreateGridModal';
import type { LocationShape, Match, RouterHistory } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
const { columnTypes } = require('../../modules/columnTypes');
import type { ColumnDef } from '@sbiteam/sbi-grid';

type Props = {
    gridsExist: boolean,
    history: RouterHistory,
    location: LocationShape,
    match: Match & { params: { filterId: string, gridId: string } },
    onDeleteGrid: (Guid, Guid) => Promise<void>,
    onAddGrid: (Guid, string, Guid) => Promise<void>,
    onAddFilter: (Guid, { [string]: string }, string, Guid) => Promise<void>,
    onDeleteFilter: (Guid, Guid, Guid) => Promise<void>,
    user: User
};
export default class Home extends Component<
    Props,
    {
        grids: Grid[],
        data: any[],
        filter: Object,
        loading: boolean,
        selectedGridId: ?Guid,
        selectedFilterId: ?Guid,
        newFilterModal: boolean,
        showShareModal: boolean,
        showDeleteModal: boolean,
        showCreateGridModal: boolean,
        columnDefinitions: ColumnDef[],
        loading: boolean
    }
> {
    constructor() {
        super();
        this.state = {
            grids: [],
            data: [],
            filter: {},
            loading: true,
            newFilterModal: false,
            showShareModal: false,
            showDeleteModal: false,
            showCreateGridModal: false,
            selectedGridId: null,
            selectedFilterId: null,
            columnDefinitions: [],
            loading: true
        };
    }
    componentDidMount() {
        this.getGridData();
    }
    componentDidUpdate(prevProps: Props) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.getGridData();
        }
    }
    getGridData() {
        let { filterId, gridId } = this.props.match.params;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        if (gridId) {
            if (filterId === 'default') {
                filterId = null;
            }
            this.setState({ loading: true, selectedGridId: gridId, selectedFilterId: filterId });

            getGridData(gridId, clientId, filterId).then(
                result =>
                    this.setState({
                        data: result.data,
                        columnDefinitions: result.columnDefinitions,
                        loading: false
                    }),
                err => console.error(err)
            );
        }
    }
    deleteFilter = () => {
        const { gridId, filterId } = this.props.match.params;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        this.setState({ showDeleteModal: false });
        return this.props.onDeleteFilter(gridId, filterId, clientId);
    };
    deleteGrid = () => {
        const { gridId } = this.props.match.params;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        return this.props
            .onDeleteGrid(gridId, clientId)
            .then(() => this.setState({ showDeleteModal: false }));
    };
    onNewFilter = (
        e: SyntheticEvent<HTMLFormElement & { filterName: HTMLInputElement }>,
        data: any
    ) => {
        const filterName = e.currentTarget.filterName.value;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        this.props
            .onAddFilter(this.props.match.params.gridId, {}, filterName, clientId)
            .then(() => this.setState({ newFilterModal: false }));
    };
    onShare = (exportType: string) => {
        this.setState({ showShareModal: true });
    };
    onNewGrid = (data: any) => {
        this.props
            .onAddGrid(data.clientId, data.name, data.storedProcedureId)
            .then(() => this.setState({ showCreateGridModal: false }));
    };
    gridApi: ?GridApi = null;
    gridColumnApi = null;
    onGridReady = (params: GridReadyEvent) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
    };
    render() {
        const props = this.props;
        const {
            loading,
            showShareModal,
            showDeleteModal,
            selectedGridId,
            columnDefinitions,
            data
        } = this.state;
        const { gridId, filterId } = props.match.params;
        const currentQuery = parse(props.location.search || '');
        const clientId = currentQuery.clientId;
        const isAdmin =
            props.user.isAdmin.length && props.user.isAdmin.indexOf(currentQuery.clientId) !== -1;
        let actionOptions = [];
        if (isAdmin) {
            if (!gridId) {
                actionOptions.push({
                    icon: 'edit',
                    onClick: () => this.setState({ showCreateGridModal: true })
                });
            } else {
                actionOptions.push(
                    { icon: 'share alternate', onClick: this.onShare },
                    {
                        icon: 'filter',
                        onClick: () => this.setState({ newFilterModal: true })
                    }
                );
                if (filterId) {
                    actionOptions.push({
                        icon: 'write',
                        onClick: () =>
                            props.history.replace(
                                assign({}, props.location, {
                                    pathname: `/grids/${gridId}/${filterId}/edit`
                                })
                            )
                    });
                }
                actionOptions.push({
                    color: 'red',
                    icon: 'delete',
                    onClick: () => this.setState({ showDeleteModal: true })
                });
            }
        }

        if (gridId && loading) {
            return <Loader active size="large">{`Loading Grids...`}</Loader>;
        }
        let deleteAction = this.deleteGrid;
        let objectType = 'Grid';
        if (filterId) {
            objectType = 'Filter';
            deleteAction = this.deleteFilter;
        }
        const exportTypes = [
            { text: 'CSV', icon: 'file outline', value: 'csv' },
            { text: 'Excel', icon: 'file excel outline', value: 'excel' }
        ];
        const noSelectionText = (
            <Grid centered columns={1} style={{ height: '100%' }}>
                <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="center">
                        {this.props.gridsExist
                            ? 'Select a grid on the left to begin.'
                            : 'You do not have any grids.'}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
        if (this.gridApi) {
            this.gridApi.hideOverlay();
        }
        if (data && data.length == 0 && this.gridApi) {
            this.gridApi.showNoRowsOverlay();
        }
        const additionalOptions = {
            parameters: [
                {
                    name: 'UserUID',
                    value: '00000000-0000-0000-0000-000000000000'
                },
                {
                    name: 'FilterUID',
                    value: filterId
                }
            ]
        };
        const defaultColumnDef = {
            editable: false,
            filter: 'text'
        };
        return (
            <div style={{ height: '100%' }} className="ag-bootstrap">
                {gridId ? (
                    <div style={{ height: '100%' }}>
                        {this.props.match.isExact && (
                            <AgGridReact
                                style={{ minHeight: '90vh' }}
                                id="Grid"
                                columnDefs={columnDefinitions}
                                defaultColDef={defaultColumnDef}
                                columnTypes={columnTypes}
                                enableFilter={true}
                                floatingFilter={true}
                                rowData={data}
                                domLayout="autoHeight"
                                onGridReady={this.onGridReady}
                            />
                        )}
                        <Route exact path={`/grids/:gridId/:filterId/edit`} component={Poseidon} />
                    </div>
                ) : (
                    noSelectionText
                )}
                {this.props.match.isExact && actionOptions.length ? (
                    <FloatingActionsHover options={actionOptions} />
                ) : null}

                <ShareModal
                    additionalOptions={additionalOptions}
                    attachmentId={gridId}
                    attachmentType={'grid'}
                    exportTypes={exportTypes}
                    onClose={() => this.setState({ showShareModal: false })}
                    open={showShareModal}
                    clientId={clientId}
                    onSavePermissions={(clientId, attachmentId, permissions) => Promise.resolve()} //TODO: wire this up
                    onShare={(attachmentId, data) => Promise.resolve()} //TODO: wire this up
                    users={[]} //TODO: send the actual users
                />
                <NewFilterModal
                    onCancel={() => this.setState({ newFilterModal: false })}
                    onSubmit={this.onNewFilter}
                    open={this.state.newFilterModal}
                />
                <CreateGridModal
                    clientId={clientId}
                    onCancel={() => this.setState({ showCreateGridModal: false })}
                    onSubmit={this.onNewGrid}
                    open={this.state.showCreateGridModal}
                    currentQuery
                />
                <DeleteModal
                    open={showDeleteModal}
                    type={objectType}
                    onCancel={() => this.setState({ showDeleteModal: false })}
                    onConfirm={() => deleteAction()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/pages/Grid.jsx